<template>
  <div class="body-div">
    <!--    <i class="fas fa-sync-alt fasRefres" @click="refreshIt"></i>-->
    <span class="btns">
      <button
        :class="isClickedDay ? 'active' : ''"
        class="btn"
        @click="giveMeDay"
      >
        TODAY
      </button>
      <button
        :class="isClickedYesterday ? 'active' : ''"
        class="btn"
        @click="giveMeYesterday"
      >
        YESTERDAY
      </button>
      <button
        :class="isClickedMonth ? 'active' : ''"
        class="btn"
        @click="giveMeLast30"
      >
        LAST 30
      </button>
      <button
        :class="isClickedThisMonth ? 'active' : ''"
        class="btn"
        @click="giveMeThisMonth"
      >
        THIS MONTH
      </button>
      <button
        :class="isClickedLastMonth ? 'active' : ''"
        class="btn"
        @click="giveMeLastMonth"
      >
        LAST MONTH
      </button>

      <label class="multi-check-label" for="check-dup">
        <input
          type="checkbox"
          class="multi-check"
          v-model="filterDup"
          id="check-dup"
        />
        DUP
      </label>
      <label class="multi-check-label" for="check-ex-dup">
        <input
          type="checkbox"
          class="multi-check"
          v-model="filterExDup"
          id="check-ex-dup"
        />
        EX-DUP
      </label>
      <label class="multi-check-label" for="check-assign-orig">
        <input
          type="checkbox"
          class="multi-check"
          v-model="filterOriginalAssign"
          id="check-assign-orig"
        />
        ORIGINAL ASSIGN
      </label>
      <label class="multi-check-label" for="check-reg">
        <input
          type="checkbox"
          class="multi-check"
          v-model="filterReg"
          id="check-reg"
        />
        FILTER REG
      </label>
      <label class="switch" for="check-on-off">
        <input
          type="checkbox"
          class="multi-check"
          id="check-on-off"
          v-model="filteringEnabled"
        />
        <span class="slider round"></span>
      </label>
    </span>
    <div class="top-div">
      <table>
        <thead>
          <tr v-if="assignStats.length > 0 || assignStats.length > 0">
            <th>
              <button
                @click="applyAlphaSorting"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fas fa-sort-alpha-down"
                  :class="{
                    'fas fa-sort-alpha-down': sortOrderAlpha === 'asc',
                    'fas fa-sort-alpha-up': sortOrderAlpha === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="magrin1">
              <button
                @click="applyAmountSortingAll"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-amount-down': sortOrderAmountAll === 'asc',
                    'fas fa-sort-amount-up': sortOrderAmountAll === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="magrin">
              <button
                @click="applyAmountSortingActive"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-amount-down': sortOrderAmountActive === 'asc',
                    'fas fa-sort-amount-up': sortOrderAmountActive === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="magrin">
              <button
                @click="applyAmountSortingNr"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-amount-down': sortOrderAmountNr === 'asc',
                    'fas fa-sort-amount-up': sortOrderAmountNr === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="magrin">
              <button
                @click="applyAmountSortingNi"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-amount-down': sortOrderAmountNi === 'asc',
                    'fas fa-sort-amount-up': sortOrderAmountNi === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="magrin">
              <button
                @click="applyAmountSortingBn"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-amount-down': sortOrderAmountBn === 'asc',
                    'fas fa-sort-amount-up': sortOrderAmountBn === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="magrin">
              <button
                @click="applyAmountSortingCa"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-amount-down': sortOrderAmountCa === 'asc',
                    'fas fa-sort-amount-up': sortOrderAmountCa === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="magrin">
              <button
                @click="applyAmountSortingNa"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-amount-down': sortOrderAmountNa === 'asc',
                    'fas fa-sort-amount-up': sortOrderAmountNa === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="magrin ">
              <button
                @click="applyAmountSortingTr"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-amount-down': sortOrderAmountTr === 'asc',
                    'fas fa-sort-amount-up': sortOrderAmountTr === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="magrin trOnline">
              <button
                @click="applyAmountSortingTrOnline"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-amount-down':
                      sortOrderAmountTrOnline === 'asc',
                    'fas fa-sort-amount-up': sortOrderAmountTrOnline === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="magrin trLive">
              <button
                @click="applyAmountSortingTrLive"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-amount-down': sortOrderAmountTrLive === 'asc',
                    'fas fa-sort-amount-up': sortOrderAmountTrLive === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="magrin ">
              <button
                @click="applyAmountSortingRf"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-amount-down': sortOrderAmountRf === 'asc',
                    'fas fa-sort-amount-up': sortOrderAmountRf === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="magrin">
              <button
                @click="applyAmountSortingLd"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-amount-down': sortOrderAmountLd === 'asc',
                    'fas fa-sort-amount-up': sortOrderAmountLd === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="magrin">
              <button
                @click="applyAmountSortingDp"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-amount-down': sortOrderAmountDp === 'asc',
                    'fas fa-sort-amount-up': sortOrderAmountDp === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="magrin">
              <button
                @click="applyAmountSortingClt"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-amount-down': sortOrderAmountClt === 'asc',
                    'fas fa-sort-amount-up': sortOrderAmountClt === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="magrin">
              <button
                @click="applyAmountSortingDev"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-amount-down': sortOrderAmountDev === 'asc',
                    'fas fa-sort-amount-up': sortOrderAmountDev === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="magrin Last">
              <button
                @click="applyAmountSortingConRate"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-amount-down': sortOrderAmountConRate === 'asc',
                    'fas fa-sort-amount-up': sortOrderAmountConRate === 'desc'
                  }"
                ></span>
              </button>
            </th>
          </tr>
          <tr
            class="bg-blue"
            v-if="
              this.assignStats.length > 0 ? this.assignStats : this.assignStats
            "
          >
            <th>AGENT</th>
            <th class="td-count">TOTAL</th>
            <!--{{ titleDayMonth }}-->
            <th class="td-count">AC</th>
            <th class="td-count">NR</th>
            <th class="td-count">NI</th>
            <th class="td-count">BN</th>
            <th class="td-count">CA</th>
            <th class="td-count">NA</th>
            <th class="td-count">TR</th>
            <th class="td-count">TR-ON</th>
            <th class="td-count">TR-LV</th>
            <th class="td-count">RF</th>
            <th class="td-count">LD</th>
            <th class="td-count">DP</th>
            <th class="td-count">CLT</th>
            <th class="td-count">DEV</th>
            <th class="td-count">CR</th>
          </tr>
        </thead>
        <tbody v-if="assignStats.length > 0">
          <tr v-for="stat in paginate(assignStats, pageNum, 7)" :key="stat.id">
            <td
              @click="
                [
                  (markIt = stat.user),
                  (filteringEnabled = true),
                  clickOnName(stat.user)
                ]
              "
            >
              <span
                class="assign-name-click"
                :class="{ marke: markIt === stat.user }"
              >
                {{ stat.user.full_name }}
              </span>
            </td>
            <td
              @click="
                [
                  (markIt = stat.user),
                  (filteringEnabled = true),
                  clickOnName(stat.user)
                ]
              "
            >
              <span
                class="assign-name-click"
                :class="{ marke: markIt === stat.user }"
              >
                {{ stat.count }}
              </span>
            </td>
            <td
              @click="
                [
                  (markActive = stat.user),
                  (filteringEnabled = true),
                  clickOnActive(stat.user)
                ]
              "
            >
              <span
                class="assign-name-click"
                :class="{ marke: markActive === stat.user }"
              >
                {{ stat.active }}
              </span>
            </td>
            <td
              @click="
                [
                  (markNr = stat.user),
                  (filteringEnabled = true),
                  clickOnNr(stat.user)
                ]
              "
            >
              <span
                class="assign-name-click"
                :class="{ marke: markNr === stat.user }"
              >
                {{ stat.NR }}
              </span>
            </td>
            <td
              @click="
                [
                  (markNi = stat.user),
                  (filteringEnabled = true),
                  clickOnNi(stat.user)
                ]
              "
            >
              <span
                class="assign-name-click"
                :class="{ marke: markNi === stat.user }"
              >
                {{ stat.NI }}
              </span>
            </td>
            <td
              @click="
                [
                  (markBn = stat.user),
                  (filteringEnabled = true),
                  clickOnBn(stat.user)
                ]
              "
            >
              <span
                class="assign-name-click"
                :class="{ marke: markBn === stat.user }"
              >
                {{ stat.BN }}
              </span>
            </td>

            <td
              @click="
                [
                  (markCa = stat.user),
                  (filteringEnabled = true),
                  clickOnCa(stat.user)
                ]
              "
            >
              <span
                class="assign-name-click"
                :class="{ marke: markCa === stat.user }"
              >
                {{ stat.CA }}
              </span>
            </td>
            <td
              @click="
                [
                  (markNa = stat.user),
                  (filteringEnabled = true),
                  clickOnNa(stat.user)
                ]
              "
            >
              <span
                class="assign-name-click"
                :class="{ marke: markNa === stat.user }"
              >
                {{ stat.NA }}
              </span>
            </td>
            <td
              @click="
                [
                  (markTr = stat.user),
                  (filteringEnabled = true),
                  clickOnTr(stat.user)
                ]
              "
            >
              <span
                class="assign-name-click"
                :class="{ marke: markTr === stat.user }"
              >
                {{ stat.TR }}
              </span>
            </td>
            <td
              @click="
                [
                  (markTrOnline = stat.user),
                  (filteringEnabled = true),
                  clickOnTrOnline(stat.user)
                ]
              "
            >
              <span
                class="assign-name-click"
                :class="{ marke: markTrOnline === stat.user }"
              >
                {{ stat.TR_ONLINE }}
              </span>
            </td>
            <td
              @click="
                [
                  (markTrLive = stat.user),
                  (filteringEnabled = true),
                  clickOnTrLive(stat.user)
                ]
              "
            >
              <span
                class="assign-name-click"
                :class="{ marke: markTrLive === stat.user }"
              >
                {{ stat.TR_LIVE }}
              </span>
            </td>
            <td
              @click="
                [
                  (markRf = stat.user),
                  (filteringEnabled = true),
                  clickOnRf(stat.user)
                ]
              "
            >
              <span
                class="assign-name-click"
                :class="{ marke: markRf === stat.user }"
              >
                {{ stat.RF }}
              </span>
            </td>
            <td
              @click="
                [
                  (markLd = stat.user),
                  (filteringEnabled = true),
                  clickOnLd(stat.user)
                ]
              "
            >
              <span
                class="assign-name-click"
                :class="{ marke: markLd === stat.user }"
              >
                {{ stat.LD }}
              </span>
            </td>
            <td
              @click="
                [
                  (markClt = stat.user),
                  (markDp = stat.user),
                  (filteringEnabled = true),
                  clickOnDp(stat.user)
                ]
              "
            >
              <span
                class="assign-name-click"
                :class="{ marke: markDp === stat.user }"
              >
                {{ stat.DP }}
              </span>
            </td>
            <td
              @click="
                [
                  (markClt = stat.user),
                  (markDp = stat.user),
                  (filteringEnabled = true),
                  clickOnCLT(stat.user)
                ]
              "
            >
              <span
                class="assign-name-click"
                :class="{ marke: markClt === stat.user }"
              >
                {{ stat.CLT }}
              </span>
            </td>

            <td>
              <span v-if="stat.DEV !== null">{{ stat.DEV.toFixed(1) }}</span
              ><span v-else>{{ stat.DEV }}</span>
            </td>
            <td>
              <span v-if="stat.conRate !== null"
                >{{ stat.conRate.toFixed(1) }}%</span
              ><span v-else>{{ stat.conRate }}%</span>
            </td>
          </tr>
          <tr
            class="borderTopLine"
            v-if="
              this.assignStats.length > 0 ? this.assignStats : this.assignStats
            "
          >
            <td></td>
            <td>{{ sumTotal().count }}</td>
            <td>{{ sumAC().active }}</td>
            <td>{{ sumNR().NR }}</td>
            <td>{{ sumNI().NI }}</td>
            <td>{{ sumBN().BN }}</td>
            <td>{{ sumCA().CA }}</td>
            <td>{{ sumNA().NA }}</td>
            <td>{{ sumTR().TR }}</td>
            <td>{{ sumTRO().TR_ONLINE }}</td>
            <td>{{ sumTRL().TR_LIVE }}</td>
            <td>{{ sumRF().RF }}</td>
            <td>{{ sumLD().LD }}</td>
            <td>{{ sumOverallDP().DP }}</td>
            <td>{{ sumClientDep().CLT }}</td>
            <td>
              {{
                (
                  sumOverallDP().DP /
                  (sumClientDep().CLT !== 0 ? sumClientDep().CLT : 1)
                ).toFixed(1)
              }}
            </td>
            <td>
              {{ ((sumOverallDP().DP / sumTotal().count) * 100).toFixed(1) }}%
            </td>
          </tr>
        </tbody>
      </table>
      <div class="loader-div" v-if="requestReportsBusy">
        <span class="insteadLoader"
          >CREATING REPORT ,PLEASE WAIT
          <div class="snippet" data-title=".dot-flashing">
            <div class="stage">
              <div class="dot-flashing"></div>
            </div>
          </div>
        </span>
      </div>
      <!--      <loader :size="'8px'" v-if="requestReportsBusy"></loader>-->
    </div>
    <div v-if="assignStats.length > 0" class="paginationContainer text-center">
      <div class="btn-group">
        <button
          v-if="pageNum !== 1"
          @click="statsBackPage"
          class="btn btn-sm s-btn-sm page-btn "
          :disabled="pageNum === 1"
        >
          <i class="fa fa-chevron-left"></i>
        </button>
        <span class="btn btn-sm s-btn-sm  page-num">
          {{ pageNum }}
        </span>
        <button
          v-if="paginate(assignStats, pageNum + 1, 7).length !== 0"
          @click="statsNextPage"
          class="btn btn-sm s-btn-sm page-btn "
        >
          <i class="fa fa-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// import Loader from "../../../../main/misc.main/loader/Loader";
import {mapGetters, mapState} from "vuex";
import apiClientCreator from "../../../../helpers/api/request";
export default {
  name: "AssignmentsStatsTable.component",
  components: {
    // Loader
  },
  data() {
    return {
      filterDup: false,
      filterOriginalAssign: false,
      filterReg: false,
      filterExDup: false,
      reqReportsBusy: false,
      requestReportsBusy: false,
      selectedTimeFrame: "DAY",
      assignStats: [],
      pageNum: 1,
      lastMonth: false,
      thisMonth: false,
      Month: false,
      day: false,
      yesterday: false,
      isClicked: false,
      isClickedYesterday: false,
      isClickedDay: false,
      isClickedMonth: false,
      isClickedLastMonth: false,
      isClickedThisMonth: false,
      titleDayMonth: "",
      sortOrderAlpha: "asc",
      sortOrderAmountAll: "asc",
      sortOrderAmountActive: "asc",
      sortOrderAmountNr: "asc",
      sortOrderAmountNi: "asc",
      sortOrderAmountBn: "asc",
      sortOrderAmountCa: "asc",
      sortOrderAmountNa: "asc",
      sortOrderAmountTr: "asc",
      sortOrderAmountTrOnline: "asc",
      sortOrderAmountTrLive: "asc",
      sortOrderAmountRf: "asc",
      sortOrderAmountLd: "asc",
      sortOrderAmountDp: "asc",
      sortOrderAmountClt: "asc",
      sortOrderAmountDev: "asc",
      sortOrderAmountConRate: "asc",
      markIt: null,
      markActive: null,
      markNr: null,
      markNi: null,
      markBn: null,
      markCa: null,
      markNa: null,
      markTr: null,
      markTrOnline: null,
      markTrLive: null,
      markRf: null,
      markLd: null,
      markDp: null,
      markClt: null,
      filteringEnabled: false,
      timeFrame: 0
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", [
      "AssigmentChoseName",
      "AssigmentChoseActive",
      "AssigmentChoseTimeForChart"
    ])
  },
  created() {
    //if(this.filteringEnabled){
    this.getAssignmentsStats(0);
    this.isClickedDay = true;
    //  }
  },
  watch: {
    filterDup: function() {
      this.getAssignmentsStats(this.timeFrame);
      if (this.filterDup && this.filterExDup) this.filterExDup = false;
    },
    filterOriginalAssign: function() {
      this.getAssignmentsStats(this.timeFrame);
    },
    filterReg: function() {
      this.getAssignmentsStats(this.timeFrame);
    },
    filterExDup: function() {
      this.getAssignmentsStats(this.timeFrame);
      if (this.filterExDup && this.filterDup) this.filterDup = false;
    }
  },

  methods: {
    sumTotal() {
      return this.assignStats.reduce((a, b) => ({
        count: a.count + b.count
      }));
    },
    sumAC() {
      return this.assignStats.reduce((a, b) => ({
        active: a.active + b.active
      }));
    },
    sumNR() {
      return this.assignStats.reduce((a, b) => ({
        NR: a.NR + b.NR
      }));
    },
    sumNI() {
      return this.assignStats.reduce((a, b) => ({
        NI: a.NI + b.NI
      }));
    },
    sumBN() {
      return this.assignStats.reduce((a, b) => ({
        BN: a.BN + b.BN
      }));
    },
    sumCA() {
      return this.assignStats.reduce((a, b) => ({
        CA: a.CA + b.CA
      }));
    },
    sumNA() {
      return this.assignStats.reduce((a, b) => ({
        NA: a.NA + b.NA
      }));
    },
    sumTR() {
      return this.assignStats.reduce((a, b) => ({
        TR: a.TR + b.TR
      }));
    },
    sumTRL() {
      return this.assignStats.reduce((a, b) => ({
        TR_LIVE: a.TR_LIVE + b.TR_LIVE
      }));
    },
    sumTRO() {
      return this.assignStats.reduce((a, b) => ({
        TR_ONLINE: a.TR_ONLINE + b.TR_ONLINE
      }));
    },

    sumRF() {
      return this.assignStats.reduce((a, b) => ({
        RF: a.RF + b.RF
      }));
    },
    sumLD() {
      return this.assignStats.reduce((a, b) => ({
        LD: a.LD + b.LD
      }));
    },
    sumOverallDP() {
      return this.assignStats.reduce((a, b) => ({
        DP: a.DP + b.DP
      }));
    },
    sumClientDep() {
      return this.assignStats.reduce((a, b) => ({
        CLT: a.CLT + b.CLT
      }));
    },
    sumDEV() {
      return this.assignStats.reduce((a, b) => ({
        DEV: a.DEV + b.DEV
      }));
    },
    sumCR() {
      return this.assignStats.reduce((a, b) => ({
        conRate: a.conRate + b.conRate
      }));
    },

    applyAlphaSorting() {
      let currentSortOrder = this.sortOrderAlpha;
      // reverse sortOrder
      if (this.sortOrderAlpha.toString() === "asc") {
        this.sortOrderAlpha = "desc";
        currentSortOrder = "desc";
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.user.full_name > b.user.full_name) {
              return -1;
            }
            if (a.user.full_name < b.user.full_name) {
              return 1;
            }
            return 0;
          });
        }
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.user.full_name > b.user.full_name) {
              return -1;
            }
            if (a.user.full_name < b.user.full_name) {
              return 1;
            }
            return 0;
          });
        }
      }

      if (this.sortOrderAlpha.toString() === "desc") {
        this.sortOrderAlpha = "asc";
        currentSortOrder = "asc";
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.user.full_name < b.user.full_name) {
              return -1;
            }
            if (a.user.full_name > b.user.full_name) {
              return 1;
            }
            return 0;
          });
        }
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.user.full_name < b.user.full_name) {
              return -1;
            }
            if (a.user.full_name > b.user.full_name) {
              return 1;
            }
            return 0;
          });
        }
      }
    },
    applyAmountSortingAll() {
      let currentSortOrder = this.sortOrderAmountAll;

      // reverse sortOrder
      if (this.sortOrderAmountAll.toString() === "asc") {
        this.sortOrderAmountAll = "desc";
        currentSortOrder = "desc";
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.count > b.count) {
              return -1;
            }
            if (a.count < b.count) {
              return 1;
            }
            return 0;
          });
        }
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.count > b.count) {
              return -1;
            }
            if (a.count < b.count) {
              return 1;
            }
            return 0;
          });
        }
      }

      //up
      if (this.sortOrderAmountAll.toString() === "desc") {
        this.sortOrderAmountAll = "asc";
        currentSortOrder = "asc";
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.count < b.count) {
              return -1;
            }
            if (a.count > b.count) {
              return 1;
            }
            return 0;
          });
        }
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.count < b.count) {
              return -1;
            }
            if (a.count > b.count) {
              return 1;
            }
            return 0;
          });
        }
      }
    },
    applyAmountSortingActive() {
      let currentSortOrder = this.sortOrderAmountActive;

      // reverse sortOrder
      if (this.sortOrderAmountActive.toString() === "asc") {
        this.sortOrderAmountActive = "desc";
        currentSortOrder = "desc";
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.active > b.active) {
              return -1;
            }
            if (a.active < b.active) {
              return 1;
            }
            return 0;
          });
        }
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.active > b.active) {
              return -1;
            }
            if (a.active < b.active) {
              return 1;
            }
            return 0;
          });
        }
      }

      //up
      if (this.sortOrderAmountActive.toString() === "desc") {
        this.sortOrderAmountActive = "asc";
        currentSortOrder = "asc";
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.active < b.active) {
              return -1;
            }
            if (a.active > b.active) {
              return 1;
            }
            return 0;
          });
        }
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.active < b.active) {
              return -1;
            }
            if (a.active > b.active) {
              return 1;
            }
            return 0;
          });
        }
      }
    },
    applyAmountSortingNr() {
      let currentSortOrder = this.sortOrderAmountNr;

      // reverse sortOrder
      if (this.sortOrderAmountNr.toString() === "asc") {
        this.sortOrderAmountNr = "desc";
        currentSortOrder = "desc";
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.NR > b.NR) {
              return -1;
            }
            if (a.NR < b.NR) {
              return 1;
            }
            return 0;
          });
        }
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.NR > b.NR) {
              return -1;
            }
            if (a.NR < b.NR) {
              return 1;
            }
            return 0;
          });
        }
      }

      //up
      if (this.sortOrderAmountNr.toString() === "desc") {
        this.sortOrderAmountNr = "asc";
        currentSortOrder = "asc";
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.NR < b.NR) {
              return -1;
            }
            if (a.NR > b.NR) {
              return 1;
            }
            return 0;
          });
        }
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.NR < b.NR) {
              return -1;
            }
            if (a.NR > b.NR) {
              return 1;
            }
            return 0;
          });
        }
      }
    },
    applyAmountSortingNi() {
      let currentSortOrder = this.sortOrderAmountNi;

      // reverse sortOrder
      if (this.sortOrderAmountNi.toString() === "asc") {
        this.sortOrderAmountNi = "desc";
        currentSortOrder = "desc";
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.NI > b.NI) {
              return -1;
            }
            if (a.NI < b.NI) {
              return 1;
            }
            return 0;
          });
        }
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.NI > b.NI) {
              return -1;
            }
            if (a.NI < b.NI) {
              return 1;
            }
            return 0;
          });
        }
      }

      //up
      if (this.sortOrderAmountNi.toString() === "desc") {
        this.sortOrderAmountNi = "asc";
        currentSortOrder = "asc";
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.NI < b.NI) {
              return -1;
            }
            if (a.NI > b.NI) {
              return 1;
            }
            return 0;
          });
        }
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.NI < b.NI) {
              return -1;
            }
            if (a.NI > b.NI) {
              return 1;
            }
            return 0;
          });
        }
      }
    },
    applyAmountSortingBn() {
      let currentSortOrder = this.sortOrderAmountBn;

      // reverse sortOrder
      if (this.sortOrderAmountBn.toString() === "asc") {
        this.sortOrderAmountBn = "desc";
        currentSortOrder = "desc";
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.BN > b.BN) {
              return -1;
            }
            if (a.BN < b.BN) {
              return 1;
            }
            return 0;
          });
        }
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.BN > b.BN) {
              return -1;
            }
            if (a.BN < b.BN) {
              return 1;
            }
            return 0;
          });
        }
      }

      //up
      if (this.sortOrderAmountBn.toString() === "desc") {
        this.sortOrderAmountBn = "asc";
        currentSortOrder = "asc";
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.BN < b.BN) {
              return -1;
            }
            if (a.BN > b.BN) {
              return 1;
            }
            return 0;
          });
        }
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.BN < b.BN) {
              return -1;
            }
            if (a.BN > b.BN) {
              return 1;
            }
            return 0;
          });
        }
      }
    },
    applyAmountSortingCa() {
      let currentSortOrder = this.sortOrderAmountCa;

      // reverse sortOrder
      if (this.sortOrderAmountCa.toString() === "asc") {
        this.sortOrderAmountCa = "desc";
        currentSortOrder = "desc";
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.CA > b.CA) {
              return -1;
            }
            if (a.CA < b.CA) {
              return 1;
            }
            return 0;
          });
        }
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.CA > b.CA) {
              return -1;
            }
            if (a.CA < b.CA) {
              return 1;
            }
            return 0;
          });
        }
      }

      //up
      if (this.sortOrderAmountCa.toString() === "desc") {
        this.sortOrderAmountCa = "asc";
        currentSortOrder = "asc";
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.CA < b.CA) {
              return -1;
            }
            if (a.CA > b.CA) {
              return 1;
            }
            return 0;
          });
        }
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.CA < b.CA) {
              return -1;
            }
            if (a.CA > b.CA) {
              return 1;
            }
            return 0;
          });
        }
      }
    },
    applyAmountSortingNa() {
      let currentSortOrder = this.sortOrderAmountNa;

      // reverse sortOrder
      if (this.sortOrderAmountNa.toString() === "asc") {
        this.sortOrderAmountNa = "desc";
        currentSortOrder = "desc";
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.NA > b.NA) {
              return -1;
            }
            if (a.NA < b.NA) {
              return 1;
            }
            return 0;
          });
        }
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.NA > b.NA) {
              return -1;
            }
            if (a.NA < b.NA) {
              return 1;
            }
            return 0;
          });
        }
      }

      //up
      if (this.sortOrderAmountNa.toString() === "desc") {
        this.sortOrderAmountNa = "asc";
        currentSortOrder = "asc";
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.NA < b.NA) {
              return -1;
            }
            if (a.NA > b.NA) {
              return 1;
            }
            return 0;
          });
        }
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.NA < b.NA) {
              return -1;
            }
            if (a.NA > b.NA) {
              return 1;
            }
            return 0;
          });
        }
      }
    },
    applyAmountSortingTr() {
      let currentSortOrder = this.sortOrderAmountTr;

      // reverse sortOrder
      if (this.sortOrderAmountTr.toString() === "asc") {
        this.sortOrderAmountTr = "desc";
        currentSortOrder = "desc";
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.TR > b.TR) {
              return -1;
            }
            if (a.TR < b.TR) {
              return 1;
            }
            return 0;
          });
        }
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.TR > b.TR) {
              return -1;
            }
            if (a.TR < b.TR) {
              return 1;
            }
            return 0;
          });
        }
      }

      //up
      if (this.sortOrderAmountTr.toString() === "desc") {
        this.sortOrderAmountTr = "asc";
        currentSortOrder = "asc";
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.TR < b.TR) {
              return -1;
            }
            if (a.TR > b.TR) {
              return 1;
            }
            return 0;
          });
        }
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.TR < b.TR) {
              return -1;
            }
            if (a.TR > b.TR) {
              return 1;
            }
            return 0;
          });
        }
      }
    },
    applyAmountSortingTrOnline() {
      let currentSortOrder = this.sortOrderAmountTrOnline;

      // reverse sortOrder
      if (this.sortOrderAmountTrOnline.toString() === "asc") {
        this.sortOrderAmountTrOnline = "desc";
        currentSortOrder = "desc";
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.TR_ONLINE > b.TR_ONLINE) {
              return -1;
            }
            if (a.TR_ONLINE < b.TR_ONLINE) {
              return 1;
            }
            return 0;
          });
        }
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.TR_ONLINE > b.TR_ONLINE) {
              return -1;
            }
            if (a.TR_ONLINE < b.TR_ONLINE) {
              return 1;
            }
            return 0;
          });
        }
      }

      //up
      if (this.sortOrderAmountTrOnline.toString() === "desc") {
        this.sortOrderAmountTrOnline = "asc";
        currentSortOrder = "asc";
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.TR_ONLINE < b.TR_ONLINE) {
              return -1;
            }
            if (a.TR_ONLINE > b.TR_ONLINE) {
              return 1;
            }
            return 0;
          });
        }
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.TR_ONLINE < b.TR_ONLINE) {
              return -1;
            }
            if (a.TR_ONLINE > b.TR_ONLINE) {
              return 1;
            }
            return 0;
          });
        }
      }
    },
    applyAmountSortingTrLive() {
      let currentSortOrder = this.sortOrderAmountTrLive;

      // reverse sortOrder
      if (this.sortOrderAmountTrLive.toString() === "asc") {
        this.sortOrderAmountTrLive = "desc";
        currentSortOrder = "desc";
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.TR_LIVE > b.TR_LIVE) {
              return -1;
            }
            if (a.TR_LIVE < b.TR_LIVE) {
              return 1;
            }
            return 0;
          });
        }
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.TR_LIVE > b.TR_LIVE) {
              return -1;
            }
            if (a.TR_LIVE < b.TR_LIVE) {
              return 1;
            }
            return 0;
          });
        }
      }

      //up
      if (this.sortOrderAmountTrLive.toString() === "desc") {
        this.sortOrderAmountTrLive = "asc";
        currentSortOrder = "asc";
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.TR_LIVE < b.TR_LIVE) {
              return -1;
            }
            if (a.TR_LIVE > b.TR_LIVE) {
              return 1;
            }
            return 0;
          });
        }
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.TR_LIVE < b.TR_LIVE) {
              return -1;
            }
            if (a.TR_LIVE > b.TR_LIVE) {
              return 1;
            }
            return 0;
          });
        }
      }
    },
    applyAmountSortingRf() {
      let currentSortOrder = this.sortOrderAmountRf;

      // reverse sortOrder
      if (this.sortOrderAmountRf.toString() === "asc") {
        this.sortOrderAmountRf = "desc";
        currentSortOrder = "desc";
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.RF > b.RF) {
              return -1;
            }
            if (a.RF < b.RF) {
              return 1;
            }
            return 0;
          });
        }
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.RF > b.RF) {
              return -1;
            }
            if (a.RF < b.RF) {
              return 1;
            }
            return 0;
          });
        }
      }

      //up
      if (this.sortOrderAmountRf.toString() === "desc") {
        this.sortOrderAmountRf = "asc";
        currentSortOrder = "asc";
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.RF < b.RF) {
              return -1;
            }
            if (a.RF > b.RF) {
              return 1;
            }
            return 0;
          });
        }
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.RF < b.RF) {
              return -1;
            }
            if (a.RF > b.RF) {
              return 1;
            }
            return 0;
          });
        }
      }
    },
    applyAmountSortingLd() {
      let currentSortOrder = this.sortOrderAmountLd;

      // reverse sortOrder
      if (this.sortOrderAmountLd.toString() === "asc") {
        this.sortOrderAmountLd = "desc";
        currentSortOrder = "desc";
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.LD > b.LD) {
              return -1;
            }
            if (a.LD < b.LD) {
              return 1;
            }
            return 0;
          });
        }
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.LD > b.LD) {
              return -1;
            }
            if (a.LD < b.LD) {
              return 1;
            }
            return 0;
          });
        }
      }

      //up
      if (this.sortOrderAmountLd.toString() === "desc") {
        this.sortOrderAmountLd = "asc";
        currentSortOrder = "asc";
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.LD < b.LD) {
              return -1;
            }
            if (a.LD > b.LD) {
              return 1;
            }
            return 0;
          });
        }
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.LD < b.LD) {
              return -1;
            }
            if (a.LD > b.LD) {
              return 1;
            }
            return 0;
          });
        }
      }
    },
    applyAmountSortingClt() {
      let currentSortOrder = this.sortOrderAmountClt;

      // reverse sortOrder
      if (this.sortOrderAmountClt.toString() === "asc") {
        this.sortOrderAmountClt = "desc";
        currentSortOrder = "desc";
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.CLT > b.CLT) {
              return -1;
            }
            if (a.CLT < b.CLT) {
              return 1;
            }
            return 0;
          });
        }
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.CLT > b.CLT) {
              return -1;
            }
            if (a.CLT < b.CLT) {
              return 1;
            }
            return 0;
          });
        }
      }

      //up
      if (this.sortOrderAmountClt.toString() === "desc") {
        this.sortOrderAmountClt = "asc";
        currentSortOrder = "asc";
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.CLT < b.CLT) {
              return -1;
            }
            if (a.CLT > b.CLT) {
              return 1;
            }
            return 0;
          });
        }
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.CLT < b.CLT) {
              return -1;
            }
            if (a.CLT > b.CLT) {
              return 1;
            }
            return 0;
          });
        }
      }
    },
    applyAmountSortingDev() {
      let currentSortOrder = this.sortOrderAmountDev;

      // reverse sortOrder
      if (this.sortOrderAmountDev.toString() === "asc") {
        this.sortOrderAmountDev = "desc";
        currentSortOrder = "desc";
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.DEV > b.DEV) {
              return -1;
            }
            if (a.DEV < b.DEV) {
              return 1;
            }
            return 0;
          });
        }
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.DEV > b.DEV) {
              return -1;
            }
            if (a.DEV < b.DEV) {
              return 1;
            }
            return 0;
          });
        }
      }
      //up
      if (this.sortOrderAmountDev.toString() === "desc") {
        this.sortOrderAmountDev = "asc";
        currentSortOrder = "asc";
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.DEV < b.DEV) {
              return -1;
            }
            if (a.DEV > b.DEV) {
              return 1;
            }
            return 0;
          });
        }
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.DEV < b.DEV) {
              return -1;
            }
            if (a.DEV > b.DEV) {
              return 1;
            }
            return 0;
          });
        }
      }
    },

    applyAmountSortingDp() {
      let currentSortOrder = this.sortOrderAmountDp;

      // reverse sortOrder
      if (this.sortOrderAmountDp.toString() === "asc") {
        this.sortOrderAmountDp = "desc";
        currentSortOrder = "desc";
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.DP > b.DP) {
              return -1;
            }
            if (a.DP < b.DP) {
              return 1;
            }
            return 0;
          });
        }
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.DP > b.DP) {
              return -1;
            }
            if (a.DP < b.DP) {
              return 1;
            }
            return 0;
          });
        }
      }

      //up
      if (this.sortOrderAmountDp.toString() === "desc") {
        this.sortOrderAmountDp = "asc";
        currentSortOrder = "asc";
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.DP < b.DP) {
              return -1;
            }
            if (a.DP > b.DP) {
              return 1;
            }
            return 0;
          });
        }
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.DP < b.DP) {
              return -1;
            }
            if (a.DP > b.DP) {
              return 1;
            }
            return 0;
          });
        }
      }
    },
    applyAmountSortingConRate() {
      let currentSortOrder = this.sortOrderAmountConRate;

      // reverse sortOrder
      if (this.sortOrderAmountConRate.toString() === "asc") {
        this.sortOrderAmountConRate = "desc";
        currentSortOrder = "desc";
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.conRate > b.conRate) {
              return -1;
            }
            if (a.conRate < b.conRate) {
              return 1;
            }
            return 0;
          });
        }
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.conRate > b.conRate) {
              return -1;
            }
            if (a.conRate < b.conRate) {
              return 1;
            }
            return 0;
          });
        }
      }

      //up
      if (this.sortOrderAmountConRate.toString() === "desc") {
        this.sortOrderAmountConRate = "asc";
        currentSortOrder = "asc";
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.conRate < b.conRate) {
              return -1;
            }
            if (a.conRate > b.conRate) {
              return 1;
            }
            return 0;
          });
        }
        if (this.assignStats.length > 0) {
          return this.assignStats.sort((a, b) => {
            if (a.conRate < b.conRate) {
              return -1;
            }
            if (a.conRate > b.conRate) {
              return 1;
            }
            return 0;
          });
        }
      }
    },

    clickOnName(user) {
      if (this.filteringEnabled) {
        this.markActive = null;
        this.markNr = null;
        this.markNi = null;
        this.markBn = null;
        this.markCa = null;
        this.markNa = null;
        this.markTr = null;
        this.markTrOnline = null;
        this.markTrLive = null;
        this.markRf = null;
        this.markLd = null;
        this.markDp = null;
        this.markClt = null;

        // let filteringType;
        // if (this.filterDup) {
        //   filteringType = "dup";
        // } else {
        //   filteringType = "unique";
        // }
        this.$store.commit(`clients/setAssigmentChoseAll`, {
          user: user,
          filter: "name",
          time: this.selectedTimeFrame,
          isOnOrOff: this.filteringEnabled,
          orig_assign: this.filterOriginalAssign,
          with_reg_date: this.filterReg,
          dup: this.filterDup,
          ex_dup: this.filterExDup
        });
      }
    },
    clickOnActive(user) {
      if (this.filteringEnabled) {
        this.markNr = null;
        this.markNi = null;
        this.markBn = null;
        this.markCa = null;
        this.markNa = null;
        this.markTr = null;
        this.markTrOnline = null;
        this.markTrLive = null;
        this.markRf = null;
        this.markLd = null;
        this.markDp = null;
        this.markClt = null;

        // let filteringType;
        // if (this.filterDup) {
        //   filteringType = "dup";
        // } else {
        //   filteringType = "unique";
        // }
        this.$store.commit(`clients/setAssigmentChoseAll`, {
          user: user,
          filter: "active",
          time: this.selectedTimeFrame,
          isOnOrOff: this.filteringEnabled,
          orig_assign: this.filterOriginalAssign,
          with_reg_date: this.filterReg,
          dup: this.filterDup,
          ex_dup: this.filterExDup
        });
      }
    },
    clickOnNr(user) {
      if (this.filteringEnabled) {
        this.markActive = null;
        this.markNi = null;
        this.markBn = null;
        this.markCa = null;
        this.markNa = null;
        this.markTr = null;
        this.markTrOnline = null;
        this.markTrLive = null;
        this.markRf = null;
        this.markLd = null;
        this.markDp = null;
        this.markClt = null;

        // let filteringType;
        // if (this.filterDup) {
        //   filteringType = "dup";
        // } else {
        //   filteringType = "unique";
        // }
        this.$store.commit(`clients/setAssigmentChoseAll`, {
          user: user,
          filter: "nr",
          time: this.selectedTimeFrame,
          isOnOrOff: this.filteringEnabled,
          orig_assign: this.filterOriginalAssign,
          with_reg_date: this.filterReg,
          dup: this.filterDup,
          ex_dup: this.filterExDup
        });
      }
    },
    clickOnNi(user) {
      if (this.filteringEnabled) {
        this.markActive = null;
        this.markNr = null;
        this.markBn = null;
        this.markCa = null;
        this.markNa = null;
        this.markTr = null;
        this.markTrOnline = null;
        this.markTrLive = null;
        this.markRf = null;
        this.markLd = null;
        this.markDp = null;
        this.markClt = null;

        // let filteringType;
        // if (this.filterDup) {
        //   filteringType = "dup";
        // } else {
        //   filteringType = "unique";
        // }
        this.$store.commit(`clients/setAssigmentChoseAll`, {
          user: user,
          filter: "ni",
          time: this.selectedTimeFrame,
          isOnOrOff: this.filteringEnabled,
          orig_assign: this.filterOriginalAssign,
          with_reg_date: this.filterReg,
          dup: this.filterDup,
          ex_dup: this.filterExDup
        });
      }
    },
    clickOnBn(user) {
      if (this.filteringEnabled) {
        this.markActive = null;
        this.markNr = null;
        this.markNi = null;
        this.markCa = null;
        this.markNa = null;
        this.markTr = null;
        this.markTrOnline = null;
        this.markTrLive = null;
        this.markRf = null;
        this.markLd = null;
        this.markDp = null;
        this.markClt = null;

        // let filteringType;
        // if (this.filterDup) {
        //   filteringType = "dup";
        // } else {
        //   filteringType = "unique";
        // }
        this.$store.commit(`clients/setAssigmentChoseAll`, {
          user: user,
          filter: "bn",
          time: this.selectedTimeFrame,
          isOnOrOff: this.filteringEnabled,
          orig_assign: this.filterOriginalAssign,
          with_reg_date: this.filterReg,
          dup: this.filterDup,
          ex_dup: this.filterExDup
        });
      }
    },
    clickOnCa(user) {
      if (this.filteringEnabled) {
        this.markActive = null;
        this.markNr = null;
        this.markNi = null;
        this.markBn = null;
        this.markNa = null;
        this.markTr = null;
        this.markTrOnline = null;
        this.markTrLive = null;
        this.markRf = null;
        this.markLd = null;
        this.markDp = null;
        this.markClt = null;

        // let filteringType;
        // if (this.filterDup) {
        //   filteringType = "dup";
        // } else {
        //   filteringType = "unique";
        // }
        this.$store.commit(`clients/setAssigmentChoseAll`, {
          user: user,
          filter: "ca",
          time: this.selectedTimeFrame,
          isOnOrOff: this.filteringEnabled,
          orig_assign: this.filterOriginalAssign,
          with_reg_date: this.filterReg,
          dup: this.filterDup,
          ex_dup: this.filterExDup
        });
      }
    },
    clickOnNa(user) {
      if (this.filteringEnabled) {
        this.markActive = null;
        this.markNr = null;
        this.markNi = null;
        this.markBn = null;
        this.markCa = null;
        this.markTr = null;
        this.markTrOnline = null;
        this.markTrLive = null;
        this.markRf = null;
        this.markLd = null;
        this.markDp = null;
        this.markClt = null;

        // let filteringType;
        // if (this.filterDup) {
        //   filteringType = "dup";
        // } else {
        //   filteringType = "unique";
        // }
        this.$store.commit(`clients/setAssigmentChoseAll`, {
          user: user,
          filter: "na",
          time: this.selectedTimeFrame,
          isOnOrOff: this.filteringEnabled,
          orig_assign: this.filterOriginalAssign,
          with_reg_date: this.filterReg,
          dup: this.filterDup,
          ex_dup: this.filterExDup
        });
      }
    },
    clickOnTr(user) {
      if (this.filteringEnabled) {
        this.markActive = null;
        this.markNr = null;
        this.markNi = null;
        this.markBn = null;
        this.markCa = null;
        this.markNa = null;
        this.markTrOnline = null;
        this.markTrLive = null;
        this.markRf = null;
        this.markLd = null;
        this.markDp = null;
        this.markClt = null;

        // let filteringType;
        // if (this.filterDup) {
        //   filteringType = "dup";
        // } else {
        //   filteringType = "unique";
        // }
        this.$store.commit(`clients/setAssigmentChoseAll`, {
          user: user,
          filter: "tr",
          time: this.selectedTimeFrame,
          isOnOrOff: this.filteringEnabled,
          orig_assign: this.filterOriginalAssign,
          with_reg_date: this.filterReg,
          dup: this.filterDup,
          ex_dup: this.filterExDup
        });
      }
    },
    clickOnTrOnline(user) {
      if (this.filteringEnabled) {
        this.markActive = null;
        this.markNr = null;
        this.markNi = null;
        this.markBn = null;
        this.markCa = null;
        this.markNa = null;
        this.markTr = null;
        this.markTrLive = null;
        this.markRf = null;
        this.markLd = null;
        this.markDp = null;
        this.markClt = null;

        // let filteringType;
        // if (this.filterDup) {
        //   filteringType = "dup";
        // } else {
        //   filteringType = "unique";
        // }
        this.$store.commit(`clients/setAssigmentChoseAll`, {
          user: user,
          filter: "trOnline",
          time: this.selectedTimeFrame,
          isOnOrOff: this.filteringEnabled,
          orig_assign: this.filterOriginalAssign,
          with_reg_date: this.filterReg,
          dup: this.filterDup,
          ex_dup: this.filterExDup
        });
      }
    },
    clickOnTrLive(user) {
      if (this.filteringEnabled) {
        this.markActive = null;
        this.markNr = null;
        this.markNi = null;
        this.markBn = null;
        this.markCa = null;
        this.markNa = null;
        this.markTr = null;
        this.markTrOnline = null;
        this.markRf = null;
        this.markLd = null;
        this.markDp = null;
        this.markClt = null;

        // let filteringType;
        // if (this.filterDup) {
        //   filteringType = "dup";
        // } else {
        //   filteringType = "unique";
        // }
        this.$store.commit(`clients/setAssigmentChoseAll`, {
          user: user,
          filter: "trLive",
          time: this.selectedTimeFrame,
          isOnOrOff: this.filteringEnabled,
          orig_assign: this.filterOriginalAssign,
          with_reg_date: this.filterReg,
          dup: this.filterDup,
          ex_dup: this.filterExDup
        });
      }
    },
    clickOnRf(user) {
      if (this.filteringEnabled) {
        this.markActive = null;
        this.markNr = null;
        this.markNi = null;
        this.markBn = null;
        this.markCa = null;
        this.markNa = null;
        this.markTr = null;
        this.markTrOnline = null;
        this.markTrLive = null;
        this.markLd = null;
        this.markDp = null;
        this.markClt = null;
        //
        // let filteringType;
        // if (this.filterDup) {
        //   filteringType = "dup";
        // } else {
        //   filteringType = "unique";
        // }
        this.$store.commit(`clients/setAssigmentChoseAll`, {
          user: user,
          filter: "rf",
          time: this.selectedTimeFrame,
          isOnOrOff: this.filteringEnabled,
          orig_assign: this.filterOriginalAssign,
          with_reg_date: this.filterReg,
          dup: this.filterDup,
          ex_dup: this.filterExDup
        });
      }
    },
    clickOnLd(user) {
      if (this.filteringEnabled) {
        this.markActive = null;
        this.markNr = null;
        this.markNi = null;
        this.markBn = null;
        this.markCa = null;
        this.markNa = null;
        this.markTr = null;
        this.markTrOnline = null;
        this.markTrLive = null;
        this.markRf = null;
        this.markDp = null;
        this.markClt = null;

        this.$store.commit(`clients/setAssigmentChoseAll`, {
          user: user,
          filter: "ld",
          time: this.selectedTimeFrame,
          isOnOrOff: this.filteringEnabled,
          orig_assign: this.filterOriginalAssign,
          with_reg_date: this.filterReg,
          dup: this.filterDup,
          ex_dup: this.filterExDup
        });
      }
    },
    clickOnDp(user) {
      if (this.filteringEnabled) {
        this.markActive = null;
        this.markNr = null;
        this.markNi = null;
        this.markBn = null;
        this.markCa = null;
        this.markNa = null;
        this.markTr = null;
        this.markTrOnline = null;
        this.markTrLive = null;
        this.markRf = null;
        this.markLd = null;
        this.markClt = null;

        // let  filteringTypeSym ="ALL_CLIENTS";
        // if (this.filterDup) {
        //   filteringTypeSym = "DUP_CLIENTS";
        // }else if(this.filterOriginalAssign){
        //   filteringTypeSym = "ORIG_ASSIGN";
        // } else if(this.filterExDup){
        //   filteringTypeSym = "EX_DUP";
        // } else if(this.filterReg){
        //   filteringTypeSym = "WITH_REG_DATE";
        // }

        this.$store.commit(`clients/setAssigmentChoseAll`, {
          user: user,
          filter: "dp",
          time: this.selectedTimeFrame,
          isOnOrOff: this.filteringEnabled,
          orig_assign: this.filterOriginalAssign,
          with_reg_date: this.filterReg,
          dup: this.filterDup,
          ex_dup: this.filterExDup
        });
      }
    },
    clickOnCLT(user) {
      if (this.filteringEnabled) {
        this.markActive = null;
        this.markNr = null;
        this.markNi = null;
        this.markBn = null;
        this.markCa = null;
        this.markNa = null;
        this.markTr = null;
        this.markTrOnline = null;
        this.markTrLive = null;
        this.markRf = null;
        this.markLd = null;
        this.markDp = null;

        // let  filteringTypeSym ="ALL_CLIENTS";
        // if (this.filterDup) {
        //   filteringTypeSym = "DUP_CLIENTS";
        // }else if(this.filterOriginalAssign){
        //   filteringTypeSym = "ORIG_ASSIGN";
        // } else if(this.filterExDup){
        //   filteringTypeSym = "EX_DUP";
        // } else if(this.filterReg){
        //   filteringTypeSym = "WITH_REG_DATE";
        // }

        this.$store.commit(`clients/setAssigmentChoseAll`, {
          user: user,
          filter: "dp",
          time: this.selectedTimeFrame,
          isOnOrOff: this.filteringEnabled,
          orig_assign: this.filterOriginalAssign,
          with_reg_date: this.filterReg,
          dup: this.filterDup,
          ex_dup: this.filterExDup
        });
      }
    },
    clickOnDev(user) {
      if (this.filteringEnabled) {
        this.markActive = null;
        this.markIt = null;
        this.markNr = null;
        this.markNi = null;
        this.markBn = null;
        this.markCa = null;
        this.markNa = null;
        this.markTr = null;
        this.markTrOnline = null;
        this.markTrLive = null;
        this.markRf = null;
        this.markLd = null;
        this.markDp = null;
        this.markClt = null;
        // this.$store.commit("clients/${filteringType}", {
        //   user: user,
        //   filter: "DEV",
        //   time: this.selectedTimeFrame,
        // isOnOrOff: this.filteringEnabled
        // });
      }
    },

    statsNextPage() {
      this.pageNum = this.pageNum + 1;
    },
    statsBackPage() {
      if (this.pageNum > 1) {
        this.pageNum = this.pageNum - 1;
      }
    },

    giveMeDay() {
      this.assignStats = "";
      this.isClickedYesterday = false;
      this.isClickedDay = true;
      this.isClickedMonth = false;
      this.isClickedThisMonth = false;
      this.isClickedLastMonth = false;
      this.selectedTimeFrame = "DAY";
      this.pageNum = 1;
      this.getAssignmentsStats(0);
      this.day = true;
      this.Month = false;
      this.thisMonth = false;
      this.lastMonth = false;
      this.yesterday = false;
      this.timeFrame = 0;
    },

    giveMeYesterday() {
      this.assignStats = "";
      this.isClickedYesterday = true;
      this.isClickedDay = false;
      this.isClickedMonth = false;
      this.isClickedThisMonth = false;
      this.isClickedLastMonth = false;
      this.selectedTimeFrame = "YESTERDAY";
      this.pageNum = 1;
      this.getAssignmentsStats(1);
      this.day = false;
      this.Month = false;
      this.thisMonth = false;
      this.lastMonth = false;
      this.yesterday = true;
      this.timeFrame = 1;
    },

    giveMeLast30() {
      this.assignStats = "";
      this.isClickedYesterday = false;
      this.isClickedDay = false;
      this.isClickedThisMonth = false;
      this.isClickedLastMonth = false;
      this.isClickedMonth = true;
      this.selectedTimeFrame = "LAST30";
      this.pageNum = 1;
      this.getAssignmentsStats(30);
      this.Month = true;
      this.day = false;
      this.yesterday = false;
      this.thisMonth = false;
      this.lastMonth = false;
      this.timeFrame = 30;
    },

    giveMeLastMonth() {
      this.assignStats = "";
      this.isClickedYesterday = false;
      this.isClickedDay = false;
      this.isClickedMonth = false;
      this.isClickedThisMonth = false;
      this.isClickedLastMonth = true;
      this.selectedTimeFrame = "LAST_MONTH";
      this.pageNum = 1;
      this.getAssignmentsStats("lm");
      this.Month = false;
      this.day = false;
      this.yesterday = false;
      this.thisMonth = false;
      this.lastMonth = true;
      this.timeFrame = "lm";
    },

    giveMeThisMonth() {
      this.assignStats = "";
      this.isClickedYesterday = false;
      this.isClickedDay = false;
      this.isClickedMonth = false;
      this.isClickedThisMonth = true;
      this.isClickedLastMonth = false;
      this.selectedTimeFrame = "THIS_MONTH";
      this.pageNum = 1;
      this.getAssignmentsStats("tm");
      this.Month = false;
      this.day = false;
      this.yesterday = false;
      this.thisMonth = false;
      this.lastMonth = true;
      this.timeFrame = "tm";
    },

    paginate(arr, page_number, page_size) {
      return arr.slice((page_number - 1) * page_size, page_number * page_size);
    },

    nextPage() {
      this.pageNum = this.pageNum + 1;
    },
    backPage() {
      if (this.pageNum > 1) {
        this.pageNum = this.pageNum - 1;
      }
    },

    getAssignmentsStats(time_frame) {
      if (
        !this.requestReportsBusy &&
        this.checkPermissions(this.auth, [1, 2, 3, 4, 12])
      ) {
        let filteringType = 0;
        ///    let filteringTypeSym = "ALL_CLIENTS";

        let filteringTimeFrame = "DAY";

        if (time_frame === "lm") {
          filteringTimeFrame = "LAST_MONTH";
        }

        if (time_frame === "tm") {
          filteringTimeFrame = "THIS_MONTH";
        }

        if (time_frame === 30) {
          filteringTimeFrame = "LAST30";
        }
        if (time_frame === 1) {
          filteringTimeFrame = "YESTERDAY";
        }
        if (time_frame === 0) {
          filteringTimeFrame = "DAY";
        }

        const params = {};

        if (this.filterDup) {
          filteringType = 1;
          ///    filteringTypeSym = "DUP_CLIENTS";
        }

        if (this.filterOriginalAssign) {
          ////  filteringTypeSym = "ORIG_ASSIGN";
          Object.assign(params, { orig_assign: true });
        }
        if (this.filterExDup) {
          ////    filteringTypeSym = "EX_DUP";
          Object.assign(params, { ex_dup: true });
        }
        if (this.filterReg) {
          ///   filteringTypeSym = "WITH_REG_DATE";
          Object.assign(params, { add_reg: true });
        }

        this.requestReportsBusy = true;
        apiClientCreator(`reports/assignments/${filteringType}/${time_frame}`)
          .get("", { params: params })
          .then(res => {
            this.assignStats = res.data;

            if (this.filteringEnabled) {
              this.$store.commit("clients/setLastModChoseTimeForChart", {
                time: "RST",
                enabled: true
              });

              this.$store.commit("clients/setAssigmentChoseTimeForChart", {
                time: filteringTimeFrame,
                enabled: true
              });

              this.$store.commit(`clients/setAssigmentChoseAll`, {
                user: null,
                filter: "all_clients",
                time: this.selectedTimeFrame,
                isOnOrOff: this.filteringEnabled,
                orig_assign: this.filterOriginalAssign,
                with_reg_date: this.filterReg,
                dup: this.filterDup,
                ex_dup: this.filterExDup
              });
            }

            this.$store.dispatch("clients/setAssigmentShowCart", {
              data: this.assignStats,
              time: filteringTimeFrame
            });

            this.requestReportsBusy = false;
            this.assignStats.sort((a, b) => {
              if (a.count > b.count) {
                return -1;
              }
              if (a.count < b.count) {
                return 1;
              }
              return 0;
            });
            this.requestReportsBusy = false;
          })
          .catch(err => {
            this.requestReportsBusy = false;
          });
      }
    },
    checkPermissions(user, permitted) {
      return permitted.some(role => role === user.user.role);
    },
    refreshIt() {
      // this.getAssignmentsDupForAMonth();
      // this.getAssignmentsDupForDay();
      this.Month ? this.giveMeLast30() : this.giveMeDay();
      this.day ? this.giveMeDay() : this.giveMeLast30();
      !this.day && !this.Month
        ? this.giveMeYesterday()
        : this.day
        ? this.giveMeDay()
        : this.giveMeLast30();
    }
  }
};
</script>

<style scoped>
.body-div {
  padding: 5px 5px 1px 5px;
  overflow-y: hidden;
  background: white;
  margin: 10px;
}
.top-div {
  width: 100%;
  height: 660px;
  margin: auto;
  background: white;
  border-radius: 3px;
  /*padding: 5px;*/
  position: relative;
}

table {
  font-size: 13px;
  width: 100%;
  height: 100%;
}
.table thead {
  border-bottom: solid 2px #eff3f6;
}
.table th {
  text-align: left;
}
.table .td-count {
  text-align: center;
}
.table td {
  border-bottom: solid 2px #eff3f6;
}
.text-center {
  font-weight: bold;
}

.paginationContainer {
  margin-top: 13px;
  font-size: 15px;
  width: 110px;
}
.page-btn {
  background: white;
}

.page-num {
  cursor: inherit;
}

.fasRefres {
  position: absolute;
  top: 640px;
  right: 970px;
  cursor: pointer;
}
.btns {
  position: relative;
  cursor: pointer;
  display: flex;
  background: white;
}

.btn {
  border: none;
  background-color: white;
  font-size: 10px;
}

.assign-name-click {
  cursor: pointer;
}

ul {
  list-style: none;
  padding-left: 0;
}

li {
  margin: 5px;
  font-size: 9pt;
  text-align: left;
}

li:hover {
  background: #e0e0e0;
  cursor: pointer;
}

.override {
  margin-left: 5px;
  margin-bottom: 5px;
  height: 20px;
  padding-top: 3px;
  font-size: 11px;
  line-height: 11px;
}

.fa {
  width: 7px;
}

.stats-table th {
  font-weight: normal;
  text-align: center;
}

.stats-table td {
  font-weight: normal;
  text-align: center;
}

.stats-table tfoot {
  border-top: #44a2d2 solid 2px;
}

.bg-blue {
  background: #44a2d2;
  color: white;
}

.bg-blue th {
  padding-right: 0px;
}

::placeholder {
  color: #b9b9b9;
  opacity: 1; /* Firefox */
}

.btn-highlight {
  box-shadow: 0 0 5px #44a2d2;
  border: 1px solid #44a2d2;
}

.paginationContainer {
  width: 110px;
  margin-left: auto;
  margin-right: auto;
}

.page-btn {
  background: white;
}

.page-num {
  cursor: inherit;
}

.multi-check-label {
  display: block;
  padding-left: -2.3rem;
  margin-right: 0.2rem;
  margin-left: 1.5rem;
  text-indent: -15px;
  font-size: 12px;
  cursor: pointer;
  margin-top: 5px;
}

.multi-check {
  width: 13px;
  height: 13px;
  padding: 0;
  margin: 0;
  vertical-align: middle;
  position: relative;
  top: -1px;
  *overflow: hidden;
}

.borderTopLine {
  border-top: 1px solid #44a2da;
}
tr th {
  text-align: center;
}
tr th:first-child {
  text-align: center;
  width: 150px !important;
}
tr th:last-child {
  text-align: center;
  width: 60px !important;
}
tr td {
  text-align: center;
}
tr td:first-child {
  text-align: left;
  width: 150px !important;
}
tr td:last-child {
  text-align: center;
  width: 60px !important;
}

.marke {
  background-color: #96d7f7;
  color: white;
}

.multi-check-label {
  display: block;
  padding-left: 0.3rem;
  margin-right: 0.2rem;
  margin-left: 1.5rem;
  text-indent: -15px;
  font-size: 12px;
  cursor: pointer;
}

.multi-check {
  width: 13px;
  height: 13px;
  padding: 0;
  margin: 0;
  vertical-align: middle;
  position: relative;
  top: -1px;
  *overflow: hidden;
}
.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 24px;
  margin-left: 20px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
  margin-left: 20px;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(16px);
  -ms-transform: translateX(16px);
  transform: translateX(16px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
/**
 * ==============================================
 * Dot Flashing
 * ==============================================
 */
.dot-flashing {
  position: relative;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  color: red;
  animation: dotFlashing 1s infinite linear alternate;
  animation-delay: 0.5s;
}

.dot-flashing::before,
.dot-flashing::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
}

.dot-flashing::before {
  left: -15px;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  color: red;
  animation: dotFlashing 1s infinite alternate;
  animation-delay: 0s;
}

.dot-flashing::after {
  left: 15px;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  color: red;
  animation: dotFlashing 1s infinite alternate;
  animation-delay: 1s;
}

@keyframes dotFlashing {
  0% {
    background-color: red;
  }
  50%,
  100% {
    background-color: #ebe6ff;
  }
}
.stage {
  position: absolute;
  left: 110%;
  top: 48%;
}
.insteadLoader {
  color: red;
  position: absolute;
  left: 45%;
  top: -22px;
}
</style>
